<template>
  <div class="main-wrap" @click="openDialog">
    <div>
      <slot></slot>
    </div>
    <el-drawer
      title="课次详情"
      :visible.sync="dialogVisible"
      direction="rtl"
      :size="590"
      destroy-on-close
      append-to-body
      @close="handleEmitUpdate"
    >
      <div class="dialog-wrap">
        <div class="block-title">
          <p class="text">基本信息</p>
          <div class="btns" v-if="dialogType === 'unsigned'">
            <div class="mwow-button success" @click="handleEditLesson">
              编辑
            </div>
            <div class="mwow-button info" @click="handleDelete">删除</div>
          </div>
        </div>
        <p class="item">
          <span class="label">上课时间：</span>
          <span class="content">{{
            `${lessonData.date.slice(5)}（周${
              this.numToWeekCh[lessonData.week_day]
            }）${lessonData.start_time.slice(0, 5)}-${lessonData.end_time.slice(
              0,
              5
            )}`
          }}</span>
        </p>
        <div class="class-name">
          <p class="item name-left">
            <span class="label">班级名称：</span>
            <span class="content mwow-green cp" @click="goClassDetail">{{
              lessonData.class.name || "-"
            }}</span>
          </p>
          <p class="p1">
            <span
              v-if="dialogType === 'signed'"
              class="mwow-button primary"
              @click="
                goHomeWork(
                  lessonData.class_id,
                  dialogType,
                  lessonData.lesson_id,
                  lessonData
                )
              "
              >发布练习>></span
            >
            <span
              v-if="dialogType !== 'signed' && lessonData.in_holiday === 2"
              class="mwow-button primary"
              @click="goHomeWork(lessonData.lesson_id, dialogType, lessonData)"
              >课次点名>></span
            >
          </p>
        </div>
        <el-row>
          <el-col :span="12">
            <p class="item">
              <span class="label">授课教师：</span>
              <span class="content">{{ lessonData.teacherStr || "-" }}</span>
            </p>
          </el-col>
          <el-col :span="12">
            <div class="item contentClass">
              <p class="label">上课教室：</p>
              <p class="content contText" v-if="lessonData.classroom">
                {{ lessonData.classroom.name }}
              </p>
              <p class="content contText" v-else>-</p>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <p class="item">
              <span class="label">授课课程：</span>
              <span class="content">{{ lessonData.course.title || "-" }}</span>
            </p>
          </el-col>
          <el-col :span="12">
            <p class="item">
              <span class="label">班级类型：</span>
              <span class="content">{{
                lessonData.class.course_type === 1 ? "1vN" : "1v1"
              }}</span>
            </p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <p class="item">
              <span class="label">授课模式：</span>
              <span class="content"
                >{{
                  lessonData.lesson_type === 1
                    ? "线下 - 门店授课"
                    : "线上 - 直播授课"
                }}
              </span>
              <span
                v-if="
                  lessonData.enter_able === 1 &&
                  myTeacherId === lessonData.main_teacher_id
                "
                class="mwow-button primary"
                style="margin-left: 50px"
                @click="handleStartLive"
                >开始授课 <i class="el-icon-d-arrow-right"></i
              ></span>
            </p>
          </el-col>
          <el-col :span="12">
            <p class="item">
              <span class="label p2">分类：</span>
              <span class="content" v-if="lessonData.class.class_type === 1"
                >正课</span
              >
              <span class="content" v-if="lessonData.class.class_type === 2"
                >体验</span
              >
              <span class="content" v-if="lessonData.class.class_type === 3"
                >补课</span
              >
            </p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <p class="item">
              <span class="label">班级人数：</span>
              <span class="content"
                >{{ lessonData.class.current_student_count }} /
                {{ lessonData.class.preset_student_count }}人（{{
                  lessonData.class.student_excess === 1 ? "可超" : "不可超"
                }}）</span
              >
            </p>
          </el-col>
          <el-col :span="12">
            <p class="item">
              <span class="label">排课课时：</span>
              <span class="content">{{
                lessonData.class.consume_number || "-"
              }}</span>
            </p>
          </el-col>
        </el-row>
        <div class="item contentClass">
          <p class="label">上课内容：</p>
          <p
            class="content contText"
            v-if="lessonData.class_lesson_extend.content"
          >
            {{ lessonData.class_lesson_extend.content }}
          </p>
          <p class="content contText" v-else>-</p>
        </div>
        <div v-if="dialogType === 'signed'">
          <div class="block-title">
            <p class="text">上课学员</p>
            <div class="btns">
              <el-button class="el-button" type="primary" @click="toRollCall"
                >编辑点名</el-button
              >
            </div>
          </div>
          <el-table
            size="mini"
            :data="tableData"
            v-horizontal-scroll
            stripe
            class="main-table"
            tooltip-effect="dark"
          >
            <el-table-column label="学员姓名" prop="name">
              <template slot-scope="scope">
                <p v-if="scope.row.student">
                  <span
                    class="mwow-green"
                    style="cursor: pointer"
                    @click="toStudentDetail(scope.row)"
                    >{{ scope.row.student.name || "-" }}</span
                  >
                  <span
                    class="mwow-tag del-filled large"
                    v-if="scope.row.student.is_del === 1"
                    >已删除</span
                  >
                  <span
                    class="mwow-tag primary-filled"
                    style="margin: 0 4px"
                    v-if="scope.row.student_type === 1"
                    >临时</span
                  >
                  <span
                    class="mwow-tag inter-filled"
                    style="margin: 0 4px"
                    v-if="scope.row.student_type === 5"
                    >体验</span
                  >
                  <span
                    class="mwow-tag del-filled"
                    style="margin: 0 4px"
                    v-if="scope.row.student_type === 3"
                    >补课</span
                  >
                  <!-- <span
                    class="mwow-tag del-filled"
                    style="margin: 0 4px"
                    v-if="scope.row.student_type === 2"
                    >调课</span
                  > -->
                </p>
                <p v-else>-</p>
              </template>
            </el-table-column>
            <el-table-column label="排课课程" prop="title">
              <template slot-scope="scope">{{
                scope.row.course && scope.row.course.title
              }}</template>
            </el-table-column>
            <el-table-column label="签到状态" prop="student_status">
              <template slot-scope="scope">
                <span class="mwow-green" v-if="scope.row.student_status === 1"
                  >到课</span
                >
                <span class="mwow-red" v-if="scope.row.student_status === 4"
                  >未到课</span
                >
                <span class="mwow-yellow" v-if="scope.row.student_status === 3"
                  >请假</span
                >
                <span class="mwow-gray" v-if="scope.row.student_status === 2"
                  >迟到</span
                >
              </template>
            </el-table-column>
            <el-table-column
              label="耗课数"
              prop="real_consume_number"
            ></el-table-column>
          </el-table>
        </div>
        <div v-if="studentAbnormalList.length > 0">
          <div class="block-title">
            <p class="text">异常学员</p>
          </div>
          <el-table
            size="mini"
            :data="studentAbnormalList"
            v-horizontal-scroll
            stripe
            class="main-table"
            tooltip-effect="dark"
          >
            <el-table-column label="学员姓名" prop="name">
              <template slot-scope="scope">
                <p v-if="scope.row.student">
                  <span
                    class="mwow-green"
                    style="cursor: pointer"
                    @click="toStudentDetail(scope.row)"
                    >{{ scope.row.student.name || "-" }}</span
                  >
                </p>
                <p v-else>-</p>
              </template>
            </el-table-column>
            <el-table-column label="排课课程" prop="title">
              <template slot-scope="scope">{{
                scope.row.course && scope.row.course.title
              }}</template>
            </el-table-column>
            <el-table-column label="签到状态" prop="student_status">
              <template>
                <span>未签到</span>
              </template>
            </el-table-column>
            <el-table-column label="消耗课时" prop="consume_number">
              <template>
                <span>0.00</span>
              </template>
            </el-table-column>
            <el-table-column label="异常原因" prop="abnormal_type">
              <template slot-scope="scope">
                <span
                  class="mwow-tag danger-filled"
                  v-if="scope.row.abnormal_type === 1"
                  >已停课</span
                >
                <span
                  class="mwow-tag primary-filled"
                  v-if="scope.row.abnormal_type === 2"
                  >已过期</span
                >
                <span
                  class="mwow-tag inter-filled"
                  v-if="scope.row.abnormal_type === 3"
                  >已超上</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="dialogType === 'unsigned'">
          <div class="block-title">
            <p class="text">上课学员</p>
            <div class="btns">
              <student-dialog
                :studentType="1"
                :lessonData="lessonData"
                v-if="lessonData.course.course_type === 1"
                @change="handleRefresh"
              >
                <div class="mwow-button-filled primary">添加临时学员</div>
              </student-dialog>
              <student-dialog
                :studentType="5"
                :lessonData="lessonData"
                v-if="lessonData.course.course_type === 1"
                @change="handleRefresh"
              >
                <div class="mwow-button-filled inter">添加体验学员</div>
              </student-dialog>
            </div>
          </div>
          <el-table
            size="mini"
            :data="tableData"
            v-horizontal-scroll
            stripe
            class="main-table"
            tooltip-effect="dark"
          >
            <el-table-column label="学员姓名" prop="name">
              <template slot-scope="scope">
                <!-- {{ scope.row.name}} -->
                <span
                  class="mwow-green"
                  style="cursor: pointer"
                  @click="toStudentDetail(scope.row)"
                  >{{ scope.row.name || "-" }}</span
                >
                <span
                  class="mwow-tag danger-filled"
                  v-if="
                    scope.row.course &&
                    scope.row.course.account.stop_status === 2
                  "
                  >已停课</span
                >
                <span
                  class="mwow-tag primary-filled"
                  v-if="
                    scope.row.course &&
                    scope.row.course.account.expire_status === 1
                  "
                  >已过期</span
                >
                <span
                  class="mwow-tag inter-filled"
                  v-if="
                    scope.row.course &&
                    Number(scope.row.course.account.usable_number) <
                      Number(scope.row.consume_number)
                  "
                  >已超上</span
                >
              </template>
            </el-table-column>
            <!-- <el-table-column label="手机号" prop="mobile">
              <template slot-scope="scope">
                {{"+"+scope.row.area_code}} {{ scope.row.mobile }}
              </template>
            </el-table-column> -->
            <el-table-column label="排课课程" prop="title">
              <template slot-scope="scope">{{
                scope.row.course ? scope.row.course.title || "-" : "-"
              }}</template>
            </el-table-column>
            <el-table-column label="签到状态" prop="student_status">
              <template slot-scope="scope">
                <div
                  :class="scope.row.student_status !== 3 ? '' : 'mwow-yellow'"
                >
                  {{ scope.row.student_status !== 3 ? "未点名" : "请假" }}
                  <span
                    class="mwow-tag del-filled large"
                    v-if="scope.row.is_del === 1"
                    >已删除</span
                  >
                  <span
                    class="mwow-tag primary-filled"
                    style="margin: 0 4px"
                    v-if="scope.row.student_type === 1"
                    >临时</span
                  >
                  <span
                    class="mwow-tag inter-filled"
                    style="margin: 0 4px"
                    v-if="scope.row.student_type === 5"
                    >体验</span
                  >
                  <span
                    class="mwow-tag del-filled"
                    style="margin: 0 4px"
                    v-if="scope.row.student_type === 3"
                    >补课</span
                  >
                  <span
                    class="mwow-tag del-filled"
                    style="margin: 0 4px"
                    v-if="scope.row.student_type === 2"
                    >调课</span
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column label="剩余课时" prop="usable_number" width="70">
              <template slot-scope="scope">
                {{
                  scope.row.course
                    ? scope.row.course.account
                      ? scope.row.course.account.usable_number
                      : "-"
                    : "-"
                }}
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              fixed="right"
              align="center"
              width="50"
              class-name="operate"
            >
              <template slot-scope="scope">
                <div
                  type="text"
                  class="mwow-gray mouse-cursor ask-for-leave"
                  v-if="
                    scope.row.student_status !== 3 &&
                    (scope.row.student_type === 3 ||
                      scope.row.student_type === 0)
                  "
                  @click="handleAskForLeave(scope.row)"
                >
                  请假
                </div>
                <div
                  type="text"
                  class="mwow-red mouse-cursor"
                  @click="handleDeleteStudent(scope.row)"
                  v-if="scope.row.student_type === 1"
                >
                  移除
                </div>
                <span
                  v-if="
                    scope.row.student_type === 5 ||
                    scope.row.student_status === 3
                  "
                  >-</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <el-pagination
          v-if="dialogType === 'unsigned'"
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="pageSizeArray"
          :style="{ float: 'right', padding: '20px' }"
          :total="total"
          :pager-count="5"
          @current-change="handlePagerChange"
          @size-change="handlePagerSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination> -->
      </div>
      <!-- 开始授课--自定义弹框 -->
      <div v-if="showConfirm" class="init-dialog">
        <div class="init-confirm" @click="showConfirm = false"></div>
        <div class="confirm-in">
          <div class="confirm-in-title">
            <p>开始授课 - {{ className }}</p>
            <p @click="concel"><i class="el-icon-close cu-po"></i></p>
          </div>
          <div class="confirm-in-info">
            <div class="confirm-in-info-icon">!</div>
            <div class="confirm-in-info-name">
              <p>
                教师可继续使用浏览器授课，或使用客户端授课；客户端授课增加了音视频课件播放功能；
              </p>
              <p class="mwow-red">
                【点击客户端授课后会完成下载并自行安装，再次点击将启动客户端开始授课】
              </p>
            </div>
          </div>
          <div class="confirm-in-btn">
            <div class="mwow-button-filled mini" @click="concel">取消</div>
            <div class="mwow-button-filled primary mini" @click="setUp">
              浏览器授课
            </div>
            <div class="mwow-button-filled success mini" @click="confirmBtn">
              客户端授课
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <!-- 课时编辑 -->
    <el-drawer
      title="课时编辑"
      :visible.sync="lessonDialogVisible"
      direction="rtl"
      :size="420"
      destroy-on-close
      append-to-body
    >
      <lesson-dialog
        :lid="lessonData.lesson_id"
        :visible.sync="lessonDialogVisible"
      ></lesson-dialog>
    </el-drawer>
  </div>
</template>
<script>
import {
  deleteLesson,
  deleteLessonStudent,
  getLessonDetail,
  abnormalStudentListApi,
  getLessonStudentList,
} from "@/api/lesson";
import { getLiveUrlApi } from "@/api/live";
import { rollCallStudentList } from "@/api/rollCall";
import studentDialog from "./studentDialog.vue";
import { UserModule } from "@/store/module/user";
import lessonDialog from "../classManagement/classDetail/lessonEditDialog.vue";

export default {
  name: "storeScheduleLessonDialog",
  components: {
    studentDialog,
    lessonDialog,
  },
  // @Prop() lid!: number;
  props: ["lid"],
  data() {
    return {
      dialogVisible: false,
      lessonDialogVisible: false,
      lessonData: {
        course: {},
        class: {},
        date: "",
        start_time: "",
        end_time: "",
        class_lesson_extend: {
          content: "-",
        },
        lesson_id: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      showConfirm: false, //显示自定义弹框,
      relationMessage: "", // 弹框信息,
      className: "", // 班级信息
      class_url: "", // 路径信息
      studentAbnormalList: [], // 异常学员数组
      numToWeekCh: {
        0: "日",
        1: "一",
        2: "二",
        3: "三",
        4: "四",
        5: "五",
        6: "六",
      },
      dialogType: "signed",
    };
  },
  // get myTeacherId() {
  //   return UserModule.userInfo.staff_id;
  // }
  computed: {
    myTeacherId() {
      return UserModule.userInfo.staff_id;
    },
  },
  methods: {
    handleAskForLeave(v) {
      this.$router.push({
        name: "leaveAppliDetails",
        query: {
          from: "storeTable",
          sid: v.student_id,
          type: "1",
          year: this.lessonData.date,
          s_time: this.lessonData.start_time,
          e_time: this.lessonData.end_time,
        },
      });
    },
    handleEditLesson() {
      this.lessonDialogVisible = true;
    },
    openDialog() {
      this.dialogVisible = true;
      this.init();
    },
    hideDialog() {
      this.dialogVisible = false;
    },
    handleEmitUpdate() {
      this.$emit("change");
    },
    init() {
      getLessonDetail({
        lesson_id: this.lid,
      }).then((res) => {
        if (res.error_code === 0) {
          const teacherStr = [];
          res.data.teacher_list.map((item) => {
            teacherStr.push(item.name);
          });
          res.data.teacherStr = teacherStr.join("、");
          this.lessonData = res.data;
          this.dialogType =
            res.data.roll_call_status === 2 ? "signed" : "unsigned";
          this.className = res.data.class.name;
          this.getList({
            page: 1,
            page_size: this.pageSize,
          });
          // 已经点名,发是否存在异常学员
          if (res.data.roll_call_status === 2) {
            abnormalStudentListApi({
              roll_call_id: res.data.roll_call_id,
            }).then((r) => {
              if (r.error_code === 0) {
                this.studentAbnormalList = r.data.list;
              }
            });
          }
        }
      });
    },
    handleRefresh(type) {
      let page = this.page;
      if (
        type === "delete" &&
        (this.page - 1) * this.pageSize + 1 === this.total
      ) {
        page = page - 1;
      }
      this.getList({
        page: page > 0 ? page : 1,
        page_size: this.pageSize,
      });
    },
    getList(params) {
      if (this.dialogType !== "signed") {
        if (!this.lessonData.lesson_id) {
          return false;
        }
        getLessonStudentList({
          // page: params.page,
          // page_size: params.page_size,
          page: 1,
          page_size: 100,
          lesson_id: this.lessonData.lesson_id,
        }).then((res) => {
          if (res.error_code === 0) {
            this.tableData = res.data.list;
            this.total = res.data.total;
            this.page = params.page;
          }
        });
      } else {
        if (!this.lessonData.class_id) {
          return false;
        }
        rollCallStudentList({
          // page: params.page,
          // page_size: params.page_size,
          page: 1,
          page_size: 100,
          class_id: this.lessonData.class_id,
          roll_call_id: this.lessonData.roll_call_id,
        }).then((res) => {
          if (res.error_code === 0) {
            this.tableData = res.data.list;
            this.total = res.data.total;
            this.page = params.page;
          }
        });
      }
    },
    handleDelete() {
      this.$confirm(
        "删除后，班级学员对应的课时都将自动删除，不能恢复。",
        `删除 - ${this.lessonData.class.name}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          iconClass: "mwow-icon-error",
        }
      )
        .then(() => {
          deleteLesson({
            lesson_ids: [this.lessonData.lesson_id],
            class_id: this.lessonData.class_id,
          }).then((res) => {
            if (res.error_code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.hideDialog();
            } else {
              this.$message({
                type: "error",
                message: "删除失败：" + res.message,
              });
            }
          });
        })
        .catch(() => {});
    },
    handleDeleteStudent(row) {
      this.$confirm(
        "移除后，本课次不再显示该学员的任何信息。",
        `移除 - ${row.name}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          iconClass: "mwow-icon-error",
        }
      )
        .then(() => {
          deleteLessonStudent({
            lesson_id: this.lessonData.lesson_id,
            student_id: row.student_id,
          }).then((res) => {
            if (res.error_code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.handleRefresh("delete");
            } else {
              this.$message({
                type: "error",
                message: "删除失败：" + res.message,
              });
            }
          });
        })
        .catch(() => {});
    },
    toRollCall() {
      this.$router.push({
        name: "rollCallDetails",
        query: { id: this.lessonData.roll_call_id },
      });
    },
    toStudentDetail(row) {
      this.$router.push({
        name: "studyDetails",
        query: { id: row.student_id },
      });
    },
    handleStartLive() {
      getLiveUrlApi({
        lesson_id: this.lessonData.lesson_id,
      }).then((res) => {
        this.showConfirm = true;
        this.class_url = res.data.url;
      });
    },
    // handlePagerChange(e: number) {
    //   this.getList({
    //     page: e,
    //     page_size: this.pageSize,
    //   });
    // }
    // handlePagerSizeChange(e: number) {
    //   this.pageSize = e;
    //   this.getList({
    //     page: 1,
    //     page_size: e,
    //   });
    // }
    // 跳转发布练习
    goHomeWork(Id, type, lid, val) {
      if (type === "signed") {
        this.$router.push({
          name: "addAfter",
          query: {
            id: Id.toString(),
            lid: lid.toString(),
            date: val.date,
          },
        });
      } else {
        this.$router.push({
          name: "classTimeDetails",
          query: {
            id: Id.toString(),
          },
        });
      }
    },
    // 跳转班级详情
    goClassDetail() {
      this.$router.push({
        name: "classManageDetail",
        query: {
          id: this.lessonData.class_id,
        },
      });
    },
    concel() {
      this.showConfirm = false;
    },
    setUp() {
      window.open(this.class_url, "_blank");
    },
    confirmBtn() {
      const win = window;
      const openUrl = this.class_url.replace("https://", "tcic://");
      win.protocolCheck(
        openUrl,
        // 成功打开的回调
        () => {
          return;
        },
        // 没有安装的回调
        () => {
          this.$message({
            type: "warning",
            message: "未安装应用，开始下载",
          });
          const agent = navigator.userAgent.toLowerCase();
          const isMac = /macintosh|mac os x/i.test(navigator.userAgent);
          const a = document.createElement("a");
          if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
            a.href =
              "https://res.qcloudclass.com/Desktop/1.6.8/TCIC_Demo_1.6.8_Setup.exe";
            a.click();
          }
          if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
            a.href =
              "https://res.qcloudclass.com/Desktop/1.6.8/TCIC_Demo_1.6.8_Setup.exe";
            a.click();
          }
          if (isMac) {
            a.href =
              "https://res.qcloudclass.com/Desktop/1.6.8/TCIC_Demo-1.6.8.dmg";
            a.click();
          }
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.main-wrap {
  height: 100%;
  flex: 1;
  line-height: 30px;
  text-align: center;
  font-size: 12px;
  cursor: pointer;
  margin-bottom: 5px;
}
.main-table {
  margin: 9px 18px;
  width: auto;
}
.dialog-wrap {
  .block-title {
    display: flex;
    line-height: 52px;
    padding: 0 18px;
    align-items: center;
    .text {
      flex: 1;
      font-size: 14px;
      color: #5c5d5e;
      font-weight: bold;
    }
    .btns {
      .mwow-button {
        margin-left: 10px;
      }
    }
  }
  .item {
    font-size: 12px;
    color: #5c5d5e;
    margin: 0 0 23px 46px;
    word-break: break-all;
    .label {
      font-weight: bold;
    }
  }
}
.p1 {
  margin-top: -7px;
}
.cp {
  cursor: pointer;
}
.class-name {
  display: flex;
  .name-left {
    margin-right: 50px;
  }
}
.contentClass {
  display: flex;
  padding-right: 18px;
  word-break: break-all;
  .contText {
    flex: 1;
  }
}
.p2 {
  margin-left: 24px;
  .init-dialog {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    margin: 0 auto;
    .init-confirm {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0.5;
      z-index: 99999;
      background: #000;
    }
    .confirm-in {
      position: absolute;
      margin: auto;
      left: 0;
      right: 0;
      top: 35%;
      width: 332px;
      min-height: 126px;
      z-index: 1000000;
      background-color: #fff;
      border-radius: 4px;
      padding: 15px;
      .confirm-in-title {
        display: flex;
        justify-content: space-between;
        p {
          font-size: 17px;
          font-weight: 400;
          color: #303133;
          margin-bottom: 20px;
        }
      }
      .confirm-in-info {
        display: flex;
        align-items: center;
        .confirm-in-info-icon {
          width: 25px;
          height: 25px;
          border-radius: 50%;
          background-color: #e6a23c;
          text-align: center;
          line-height: 25px;
          font-size: 18px;
          color: #fff;
          margin-right: 11px;
        }
        .confirm-in-info-name {
          flex: 1;
          color: #606266;
          font-size: 14px;
          line-height: 20px;
        }
      }
      .confirm-in-btn {
        margin-top: 15px;
        float: right;
        div {
          margin-left: 10px;
        }
      }
    }
  }
}
/deep/ .el-table__row {
  .operate {
    text-align: left !important;
  }
}
.ask-for-leave {
  font-size: 12px;
  &:hover {
    color: #07d1aa !important;
  }
}
</style>
